import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=7d6f7261&scoped=true&"
import script from "./GroupItem.vue?vue&type=script&lang=js&"
export * from "./GroupItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=7d6f7261&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f7261",
  null
  
)

export default component.exports